import * as React from 'react';

import { TrendBlocContainer } from 'modules/shared-cms-advanced';
import { ProductThumbnail } from 'modules/catalogue/components';

import { TrendCatalogueBlocContainerProps } from '.';

export const TrendCatalogueBlocContainer: React.FC<TrendCatalogueBlocContainerProps> = ({
    products,
    ...rest
}: TrendCatalogueBlocContainerProps) => {
    if (products.length > 0) {
        return (
            <TrendBlocContainer {...rest}>
                {products.map((product, index) => {
                    // eslint-disable-next-line react/no-array-index-key
                    return <ProductThumbnail key={`${product.id}-${index}`} product={product} centerLabels />;
                })}
            </TrendBlocContainer>
        );
    }

    return <React.Fragment />;
};
